import axios from "axios";
import { get } from "lodash";
import tvgConf from "@tvg/conf";

const instance = axios.create();

function getInstance() {
  if (tvgConf().isRN) {
    if (get(global, "session.sessionId")) {
      // @ts-ignore
      instance.defaults.headers.common["tvg-session-id"] = get(
        global,
        "session.sessionId",
        ""
      );
    }
  }

  return instance;
}

export default getInstance;
